module.exports = __webpack_public_path__ + "static/grt8-logo-10cf30508d9724eece0024d06e48e907.png";